import React from "react";
import { useCountUp } from "../../animations/hooks";

/**
 * Number that counts up from 0 when scrolled into view.
 *   <CountUp value={74000} prefix="RM " />
 */
function CountUp({ value, duration, prefix, suffix, decimals, locale, className, as: Tag = "span" }) {
    const ref = useCountUp(value, { duration, prefix, suffix, decimals, locale });
    return <Tag ref={ref} className={className} />;
}

export default CountUp;
